/* eslint-disable no-unused-vars */

import StyledHero from "./styles"

import React, { useRef, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Helmet } from "react-helmet"
import Slider from "react-slick"

import Button from "components/Button"

import { useLocale } from "context/locale"

const Hero = ({ heroPosts }) => {
  const { t } = useLocale()

  const [currentSlide, setCurrentSlide] = useState(0)

  const background_slider = useRef(null)
  const text_slider = useRef(null)
  const images_slider = useRef(null)

  const data = useStaticQuery(
    graphql`
      query {
        hero_first_mobile: file(
          relativePath: { eq: "home_hero/hero_first_mobile.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )

  const background_settings = {
    dots: false,
    infinite: true,
    swipe: false,
    arrows: false,
    autoplay: false,
    speed: 1200,
    ref: background_slider,
  }
  // const images_settings = {
  //   dots: false,
  //   infinite: true,
  //   swipe: false,
  //   arrows: false,
  //   autoplay: true,
  //   speed: 1000,
  //   autoplaySpeed: 10000,
  //   pauseOnHover: false,
  //   ref: images_slider,
  // }
  const text_settings = {
    fade: true,
    dots: false,
    infinite: true,
    swipe: false,
    arrows: false,
    autoplay: false,
    speed: 1200,
    // autoplaySpeed: 10000,
    pauseOnHover: false,
    ref: text_slider,
    afterChange: index => {
      setCurrentSlide(index)
    },
  }

  const sliderBackgrounds = [
    require("images/refresh/1920X938_SLIDER_1.jpg").default,
    require("images/refresh/1920X938_SLIDER_NIE_KUPUJ_ADOPTUJ.jpg").default,
    require("images/refresh/1920X938_SLIDER_NIE_SZUKAJ_DZIURY_W_CALYM.jpg")
      .default,
  ]

  return (
    <StyledHero>
      <Helmet>
        <link
          rel="preload"
          href={data.hero_first_mobile.childImageSharp.fluid.src}
          imagesrcset={data.hero_first_mobile.childImageSharp.fluid.srcSet}
          as="image"
        />
      </Helmet>

      <div className="home-hero__background-slider">
        <Slider {...background_settings}>
          {sliderBackgrounds.map((item, index) => (
            <div key={index}>
              <div
                className="slide-inner"
                style={{
                  backgroundImage: `url('${item}')`,
                }}
              />
            </div>
          ))}
        </Slider>
      </div>
      <div className="home-hero__inner">
        <button
          onClick={() => {
            setTimeout(() => {
              background_slider?.current?.slickPrev()
              text_slider?.current?.slickPrev()
            }, 1200)
            images_slider?.current?.slickPrev()
          }}
          type="button"
          aria-label="arrow-prev"
          className="circle-arrow prev"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10.294"
            height="17.759"
            viewBox="0 0 10.294 17.759"
          >
            <path
              d="M8.88,16.7.707,8.526,8.88.354"
              transform="translate(0.707 0.353)"
              fill="none"
              stroke="#fff"
              strokeWidth="2"
            />
          </svg>
        </button>
        <button
          onClick={() => {
            setTimeout(() => {
              background_slider?.current?.slickNext()
              text_slider?.current?.slickNext()
            }, 1200)
            images_slider?.current?.slickNext()
          }}
          type="button"
          aria-label="arrow next"
          className="circle-arrow next"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10.294"
            height="17.759"
            viewBox="0 0 10.294 17.759"
          >
            <path
              d="M.707,16.7,8.88,8.526.707.354"
              transform="translate(0 0.353)"
              fill="none"
              stroke="#fff"
              strokeWidth="2"
            />
          </svg>
        </button>
        <div className="main-container">
          <div className="home-hero__wrapper">
            <header className="home-hero__header">
              <Slider {...text_settings}>
                <div>
                  {/* <h1 className="title">Together we play for the planet.</h1> */}
                  <img
                    src={
                      require("images/refresh/4F_MOVING_TOWARDS_CIRCULARITY.svg")
                        .default
                    }
                    alt=""
                  />
                  {/* <p className="desc bolder">Let's play it fair.</p> */}
                  <Button
                    text={t("Join")}
                    as="link"
                    href={t("join_link")}
                    theme="black-border"
                    className="header-button"
                  />
                </div>
                {heroPosts?.nodes?.map((item, index) => (
                  <div key={index}>
                    {/* <h1 className="title">{item.title}</h1> */}
                    <img
                      src={
                        require("images/refresh/4F_MOVING_TOWARDS_CIRCULARITY.svg")
                          .default
                      }
                      alt=""
                    />
                    {/* <p className="desc bolder">
                      {item.acfPost.postHomeHeroExcerpt
                        ? item.acfPost.postHomeHeroExcerpt
                        : item.excerpt}
                    </p> */}
                    <Button
                      text={t("more")}
                      as="link"
                      href={`/aktualnosci/${item.slug}/`}
                      theme="black-border"
                      className="header-button"
                    />
                  </div>
                ))}
              </Slider>
            </header>
            <div className="home-hero__image-claim">
              <img
                src={require("images/refresh/4F_CIRCULARITY.png").default}
                alt=""
              />
            </div>

            {/* <div className="home-hero__image-slider">
              <div className="slider-overlay">
                <Slider {...images_settings}>
                  <div>
                    <div
                      className="slide-inner"
                      style={{
                        backgroundImage: `url('${
                          require("images/home_hero/hero_first.jpg").default
                        }')`,
                      }}
                    />
                  </div>
                  {heroPosts?.nodes?.map((item, index) => (
                    <div key={index}>
                      <div
                        className="slide-inner"
                        style={{
                          backgroundImage: `url('${
                            item?.acfPost?.postHomeHeroImage?.localFile
                              ?.publicURL
                              ? item?.acfPost?.postHomeHeroImage?.localFile
                                  ?.publicURL
                              : item.featuredImage.node.localFile.publicURL
                          }')`,
                        }}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
              <div className="slider-count">
                {currentSlide + 1} <span></span> {heroPosts?.nodes.length + 1}
              </div>
              <button
                onClick={() => {
                  setTimeout(() => {
                    background_slider?.current?.slickPrev()
                    text_slider?.current?.slickPrev()
                  }, 1200)
                  images_slider?.current?.slickPrev()
                }}
                type="button"
                aria-label="arrow-prev"
                className="circle-arrow prev mobile"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10.294"
                  height="17.759"
                  viewBox="0 0 10.294 17.759"
                >
                  <path
                    d="M8.88,16.7.707,8.526,8.88.354"
                    transform="translate(0.707 0.353)"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                </svg>
              </button>
              <button
                onClick={() => {
                  setTimeout(() => {
                    background_slider?.current?.slickNext()
                    text_slider?.current?.slickNext()
                  }, 1200)
                  images_slider?.current?.slickNext()
                }}
                type="button"
                aria-label="arrow next"
                className="circle-arrow next mobile"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10.294"
                  height="17.759"
                  viewBox="0 0 10.294 17.759"
                >
                  <path
                    d="M.707,16.7,8.88,8.526.707.354"
                    transform="translate(0 0.353)"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                </svg>
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </StyledHero>
  )
}

export default Hero
